<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Recherche de produit par nom </div>
        <div class="modal-body">
            <div class="all-container">
                <div class="search-result-container">
                    <div class="search">
                        <frg-search-input (search)="onSearchMed($event)"></frg-search-input>
                    </div>
                    <div *ngIf="!medBodyTable || medBodyTable.objects.length === 0">
                        Aucune spécialité médicamenteuse trouvée. Veuillez saisir ou modifier la recherche.
                    </div>
                    <div class="table">
                        <frg-table [keysBody]="medBodyTable" [keysColumn]="medColumnTable" [isRowsClickable]="true"
                            (onClickRow)="selectMed($event)" [loading]="isLoadingSearch">
                        </frg-table>
                    </div>
                </div>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeSearchMed()" [backgroundColor]="'var(--darkest-primary)'">Annuler
                </frg-button>
                <frg-button [backgroundColor]="'var(--primary)'" (activated)="closeSearchMed(selectedMed)">
                    Valider</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>